import React from 'react';
import cofre112v2 from './../images/cofre112v2.png';
import biruxBronce112 from './../images/biruxBronce112.png';
import biruxComodin112 from './../images/biruxComodin112.png';
import biruxPlata112 from './../images/biruxPlata112.png';
import biruxOro112 from './../images/biruxOro112.png';

// Iconos de los premios que no son recompensas del catalogo. El servidor manda el nombre del
// fichero en prize.icon; las recompensas traen su URL ya montada en prize.image.
//
// Compartido por la tabla de /games y por el overlay de OBS, para que no se separen.
const PRIZE_ICONS = {
    'cofre112v2.png': cofre112v2,
    'biruxBronce112.png': biruxBronce112,
    'biruxComodin112.png': biruxComodin112,
    'biruxPlata112.png': biruxPlata112,
    'biruxOro112.png': biruxOro112,
};

// Solo va la imagen; el detalle ("20 Overbox") queda en el alt y el title, para que salga como
// tooltip y para que siga siendo legible sin ver la imagen.
export const prizeImage = (prize, className = 'prizeImage') => {
    if (!prize) return null;
    const src = prize.image || PRIZE_ICONS[prize.icon];
    if (!src) return null;
    return <img className={className} src={src} alt={prize.label} title={prize.label} />;
};

// Igual pero con la cantidad al lado cuando hay mas de uno ("x20"). En el directo no hay
// tooltip que valga: si el premio son 20 overbox, el numero tiene que verse.
export const prizeWithAmount = (prize, className = 'prizeImage', amountClassName = 'prizeAmount') => {
    const img = prizeImage(prize, className);
    if (!img) return null;
    const amount = Number(prize.amount) || 1;
    if (amount <= 1) return img;
    return (
        <>
            {img}
            <span className={amountClassName}>x{amount}</span>
        </>
    );
};

export default prizeImage;
